class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    //handleShippingProtection();
    
     // shippingcheck()
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);




function shippingcheck() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Check if the total items in the cart are exactly one
      if (cart.item_count === 1) {
        const shippingRowSelectors = 'div#CartDrawer tr.cart-item.cart-item-Shipping.Protection';
        if (!document.querySelector(shippingRowSelectors)) {
         document.querySelector('.shipping-container .switch input').checked = true;
         document.querySelector('.shipping-right .shipping-atc-container button').click();
         return;
       }
      }

      // Otherwise, check for a product with the handle 'shipping-protection'
      const hasProductWithHandle = cart.items.some(item => item.handle === 'shipping-protection');
      if (hasProductWithHandle) {
        console.log('Product with handle "shipping-protection" is in the cart.');
        document.querySelector('.shipping-container .switch input').checked = true;
      } else {
        document.querySelector('.shipping-container .switch input').checked = false;
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}

// document.addEventListener('click', function (e) {
//   const form = e.target.closest('form');
  
//   if (!e.target.classList.contains('ev-mammoth-atc')) return;

//   e.preventDefault();

//   const spinner = form.querySelector('.loading-overlay__spinner');
//   const spanText = form.querySelector('span');
//   const main_button = form.querySelector('.ev-mammoth-atc');
//   spinner.classList.remove('hidden');
//   spanText.style.display = "none";
//   main_button.classList.add('loading');

//   const formData = new FormData(form);
//   const variantId = formData.get('id');

//   let quantity = 1;
//   const qtyInput = form.querySelector('.xb-upsell-input[name="quantity"]');
//   const mainqtyInput = form.querySelector('.quantity__input');
//   if (qtyInput) {
//     quantity = parseInt(qtyInput.value) || 1;
//   } else if (mainqtyInput) {
//     quantity = parseInt(mainqtyInput.value) || 1;
//   }

//   const GIFT_VARIANT_ID = 49962879189272;

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({
//       items: [
//         { id: parseInt(variantId), quantity: quantity },
//         { id: GIFT_VARIANT_ID, quantity: quantity }
//       ]
//     })
//   })
//     .then(res => res.json())
//     .then(data => {
//       return fetch("/cart/update.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ updates: {}, sections: ["cart-drawer", "cart-icon-bubble"] }),
//       })
//         .then(res => res.json())
//         .then(cart => {
//           document.querySelector("cart-drawer").renderContents(cart);
//           document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
//         });
//     })
//     .catch(err => {
//       console.error('Add to cart failed:', err);
//     })
//     .finally(() => {
//       // Remove loader and show text again
//       spinner.classList.add('hidden');
//       spanText.style.display = "";
//       main_button.classList.remove('loading');
//     });
// });


var Shopify = Shopify || {};

Shopify.money_format = "${{amount}}"; // or set to "₹{{amount}}" for INR

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};






function handleShippingProtection() {
  const variantId = 50514579161368; // <-- Replace with your actual variant ID
  const toggle = document.getElementById("shipping-toggle");
 
  function addProtection() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(res => res.json())
      .then(data => {
        console.log('Shipping protection added:', data);
  
        // Now fetch the updated cart
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cart => {
        console.log('Updated Cart object:', cart);
        console.log(Shopify.formatMoney(cart.total_price));
        $(".checkouttoal .totals__subtotal-value").text(Shopify.formatMoney(cart.total_price));
      })
      .catch(err => {
        console.error('Error:', err);
      });
  }


   function removeProtection(itemKey) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    })
      .then(res => res.json())
      .then(data => {
        console.log('Shipping protection removed:', data);
  
        // Now fetch the updated cart
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cart => {
        console.log('Updated Cart object:', cart);
        $(".checkouttoal .totals__subtotal-value").text(Shopify.formatMoney(cart.total_price));
      })
      .catch(err => {
        console.error('Error:', err);
      });
  }


  // Check on page load whether protection is already in cart
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const existing = cart.items.find(i => i.variant_id === variantId);
    if(!existing){
       addProtection();
  toggle.checked = true;
    }
     // toggle.checked = !!existing; // true if item found, false otherwise
      
    });

  // Toggle change listener
  toggle.addEventListener("change", function () {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const existing = cart.items.find(i => i.variant_id === variantId);

        if (toggle.checked) {
          if (!existing) {
            addProtection();
          }
        } else {
          if (existing) {
            removeProtection(existing.key);
          }
        }
      });
  });
}
